const UCI_MOVE = /^[a-h][1-8][a-h][1-8][qrbn]?$/;

export const moveUciToObj = move => ({ from: move.slice(0, 2), to: move.slice(2, 4), ...(move[4] ? { promotion: move[4] } : {}) });

// UCI fields are optional and can change order. PV runs to the end of the line;
// old Stockfish.js builds appended a nonstandard "bmc" field.
export function parseInfo(line, turn = 'w') {
  if (typeof line !== 'string' || !/^info\s/.test(line) || /^info\s+string\b/.test(line)) return null;
  const depth = line.match(/\bdepth\s+(\d+)/);
  const score = line.match(/\bscore\s+(cp|mate)\s+(-?\d+)/);
  const pv = line.match(/\bpv\s+(.+)/);
  if (!depth || !score || !pv || /\b(?:upperbound|lowerbound)\b/.test(line)) return null;
  const moves = [];
  for (const token of pv[1].trim().split(/\s+/)) {
    if (!UCI_MOVE.test(token)) break;
    moves.push(moveUciToObj(token));
  }
  if (!moves.length) return null;
  const multiPv = Number(line.match(/\bmultipv\s+(\d+)/)?.[1] || 1);
  if (multiPv < 1) return null;
  return {
    index: multiPv - 1,
    depth: Number(depth[1]),
    score: Number(score[2]) * (turn === 'b' ? -1 : 1),
    mate: score[1] === 'mate',
    pv: moves,
  };
}
